import { formatDate } from '@utils';
import { omit } from 'lodash-es';
import { FILTER_OPERATOR_ENUMS, FILTER_RULE_ENUMS } from '@constants';

export const handleTiresData = (data = []) => {
  if (!data) {
    return [];
  }

  return data?.map((item) => ({
    id: item.id,
    vendorReferenceId: item.vendorReferenceId,
    vendor: item.vendor?.name || '-',
    status: item.status || 'UNKNOWN',
    description: item.properties.description,
    grade: item.properties.grade || '-',
    wet: item.properties.wet || '-',
    noiseGrade: item.properties.noiseGrade || '-',
    supplierItemCode: item.properties.supplierItemCode || '-',
    fuelEfficiency: item.properties.fuelEfficiency || '-',
    category: item.properties.category || '-',
    noiseDB: item.properties.noiseDB || '-',
    price: item.properties.price ? `${item.properties.price.number}€` : '-',
    brand: item.properties.brand || '-',
    image: item.properties.imageURL || '-',
    tire: item.tire,
    createdAt: item.createdAt
      ? formatDate(item.createdAt, 'dd/MM/yyyy HH:mm:ss')
      : '-',
    updatedAt: item.updatedAt
      ? formatDate(item.updatedAt, 'dd/MM/yyyy HH:mm:ss')
      : '-',
    deletedAt: item.deletedAt
      ? formatDate(item.deletedAt, 'dd/MM/yyyy HH:mm:ss')
      : '-',
  }));
};

export const getSearchRequestPayload = (payload = {}) => {
  const fields = omit(payload, ['page', 'pageSize', 'query']) || {};
  const keys = Object.keys(fields);

  if (keys.length === 0) {
    return null;
  }

  const value = keys.map((key) => {
    if (fields[key].includes(',')) {
      return {
        field: key,
        operator: FILTER_OPERATOR_ENUMS['='],
        type: FILTER_RULE_ENUMS.IsAnyOfRuleType,
        value: fields[key].split(','),
      };
    }

    return {
      field: key,
      operator: FILTER_OPERATOR_ENUMS['='],
      type: FILTER_RULE_ENUMS.ComparableRuleType,
      value: fields[key],
    };
  });

  return {
    type: 0,
    value,
  };
};
